export default {
  title: 'Booking Availabilities',
};
